import { useStyletron } from 'baseui';

type UseStylesProps = {
	height?: string;
};

const useStyles = ({ height }: UseStylesProps) => {
	const [css, theme] = useStyletron();
	const listStyle = css({
		height: height || 'calc(100vh - 160px)',
		overflow: 'scroll',
		background: '#fafcff' // to make search bar visible
	});
	const actionStyle = css({
		position: 'absolute',
		right: '10px',
		bottom: '50px',
		display: 'flex',
		flexDirection: 'column',
		cursor: 'pointer',
		gap: '10px'
	});
	const individualStyle = css({
		borderRadius: '50%',
		background: theme.colors.contentPrimary,
		color: theme.colors.contentInversePrimary
	});

	return { listStyle, actionStyle, individualStyle };
};
export default useStyles;
